import React from 'react';
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Home from "./Home";
import Cases from "./Cases";
import Contact from "./Contact";
import Sidebar from "../components/Sidebar";
import Login from "../pages/amdin/Login";
import ChangePassword from "../pages/amdin/ChangePassword";
import Dashboard from "../pages/amdin/DashboardLayout";
import CaseList from "./amdin/CaseList";
import SalesContact from "./amdin/SalesContact";
import {SidebarProvider} from "../contexts/SidebarContext";

// 获取默认语言
const getDefaultLanguage = (): string => {
    return localStorage.getItem('language') || 'en';
};

// 判断是否是管理后台
const isAdminDomain = (): boolean => {
    return window.location.hostname.startsWith('admin');
};

// 验证管理员登录状态
const RequireAuth = ({children}: { children: JSX.Element }) => {
    const isAuthenticated = localStorage.getItem('adminUser');

    if (!isAuthenticated) {
        return <Navigate to="/login" replace/>;
    }

    return children;
};

const IndexPage = () => {
    if (isAdminDomain()) {
        // 管理后台路由
        return (
            <div className="min-h-screen flex flex-col">
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<Login/>}/>
                        <Route path="*" element={<Navigate to="/" replace/>}/>
                        <Route
                            path="/"
                            element={
                                <RequireAuth>
                                    <Dashboard/>
                                </RequireAuth>
                            }>
                            <Route index element={<Navigate to="/manage-cases" replace/>}/>
                            <Route path="manage-cases" element={<CaseList/>}/>
                            <Route path="sales-contact" element={<SalesContact/>}/>
                            <Route path="change-password" element={<ChangePassword/>}/>
                            <Route path="/" element={<Navigate to="/change-password" replace/>}/>
                        </Route>
                    </Routes>
                </BrowserRouter>
            </div>
        );
    }

    // 前台网站路由
    return (
        <div className="min-h-screen flex flex-col">
            <BrowserRouter>
                <SidebarProvider>
                    <Header/>
                    <main className="flex-grow">
                        <Sidebar/>
                        <Routes>
                            {/* 重定向根路径到默认语言 */}
                            <Route
                                path="/"
                                element={<Navigate to={`/${getDefaultLanguage()}`} replace/>}
                            />

                            {/* 英文路由 */}
                            <Route path="/en" element={<Home/>}/>
                            <Route path="/en/cases" element={<Cases/>}/>
                            <Route path="/en/contact" element={<Contact/>}/>

                            {/* 中文路由 */}
                            <Route path="/zh" element={<Home/>}/>
                            <Route path="/zh/cases" element={<Cases/>}/>
                            <Route path="/zh/contact"/>

                            <Route
                                path="*"
                                element={<Navigate to={`/${getDefaultLanguage()}`} replace/>}
                            />
                        </Routes>
                    </main>
                    <Footer/>
                </SidebarProvider>
            </BrowserRouter>
        </div>
    );
}

export default IndexPage;
